import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";


const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) ;
let companyCode = null

if (storedUserDataArray) {
  companyCode = storedUserDataArray[0].cmpcode
}

const getEmployees = async (searchdata) => {
    const responce = await axios.get(`${base_url}/api/PersonalInfoList/${companyCode}/ALL/YES/${searchdata ? searchdata : '-'}`);
    if (responce.data) {
        return responce.data
    }
}


const getEmps = async () => {
    const responce = await axios.get(`${base_url}/api/MasterList/${companyCode}/JOBTITLE/-`);
    if (responce.data) {
        return responce.data
    }
}

const createEmps = async (values) => {
    const responce = await axios.post(`${base_url}/api/MasterReg/ENTRY/${companyCode}/JOBTITLE/${values.description}/-`);
    if (responce.data) {
        return responce.data
    }
}

const Empdtls = async (empId) => {
    const responce = await axios.get(`${base_url}/api/PersonalInfoList/${companyCode}/SINGLE/YES/${empId}/ALL/ALL/ALL`);
    if (responce.data) {
        return responce.data
    }
}

const createAllowance = async (values) => {
    const responce = await axios.post(`${base_url}/api/PersonalInfoAllowanceReg`, values);
    if (responce.data) {
        return responce.data
    }
}

const createIncrement = async (values) => {
    const responce = await axios.post(`${base_url}/api/PersonalInfoIncrementReg`, values);
    if (responce.data) {
        return responce.data
    }
}

const getAllowance = async (emp) => {
    console.log("getAllowance called")
    const responce = await axios.get(`${base_url}/api/PersonalInfoAllowanceList/${companyCode}/${emp}`);
    if (responce.data) {
        return responce.data
    }
}


const getIncrement = async (emp) => {
    const responce = await axios.get(`${base_url}/api/PersonalInfoIncrementList/${companyCode}/${emp}`);
    if (responce.data) {
        return responce.data
    }
}



export const empService = {
    getEmps,
    createEmps,
    Empdtls,
    createAllowance,
    createIncrement,
    getAllowance,
    getIncrement,
    getEmployees
}